"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _InterestPaymentsTableComponent = _interopRequireDefault(require("./InterestPaymentsTableComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    themeModifier: ownProps.themeModifier
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_InterestPaymentsTableComponent["default"]);